module.exports = __webpack_public_path__ + "media/categories/1074-4114828c.svg";